module.exports = __webpack_public_path__ + "media/Resources/Product-3defd67e.svg";